const loginForm = document.getElementById('customer_login');
const email = loginForm.querySelector('#customer_email')
const password = loginForm.querySelector('#customer_password')

const GQL_ENDPOINT = 'https://bagasiku-com.myshopify.com/api/2026-01/graphql.json'

async function executeLogin() {
  try {
    const mutationAccessToken = `
      mutation customerAcessTokenCreate($email: String!, $password: String!) {
        customerAccessTokenCreate(input: { email: $email, password: $password }) {
          customerAccessToken {
              accessToken
          }
          customerUserErrors {
              message
          }
        }
      } 
    `

    const loginVariable = {
      email: email.value,
      password: password.value
    }

    const response = await fetch(GQL_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'a6170cd5ac9085cb8648839b81686156'
      },
      body: JSON.stringify({
        query: mutationAccessToken,
        variables: loginVariable
      })
    })

    const { data } = await response.json();
    if (data.customerAccessTokenCreate.customerAccessToken) {
      const accessToken = data.customerAccessTokenCreate.customerAccessToken.accessToken
      localStorage.setItem('accessToken', accessToken)
      // window.location.href = '/account'

      // submit the login form
      loginForm.submit()
    } else {
      alert(data.customerAccessTokenCreate.customerUserErrors[0].message)
    }
  } catch (error) {
    console.error('Network Error:', error);
  }
}

if (loginForm) {
  loginForm.addEventListener('submit', (e) => {
    e.preventDefault();
    executeLogin()
  });
}